// Set styling logic - extracted from set-card-helpers.tsx
import { SET_STATUSES, type SetStatus } from "@workspace/types";

// ===== STYLING UTILITIES =====

/**
 * Gets CSS classes for set card background based on status
 */
export function getSetCardClassName(
	status: SetStatus,
	variant: "card" | "calendar" = "card",
): string {
	const baseClass =
		variant === "calendar" ? "bg-card border border-border" : "border";

	switch (status) {
		case SET_STATUSES.SAW_LIVE:
			return "bg-radix-indigo-4 dark:bg-radix-indigo-9/30 border border-radix-indigo-6 dark:border-radix-indigo-6/10";
		case SET_STATUSES.SAW_STREAM:
			return "bg-radix-ruby-4 dark:bg-radix-ruby-9/30 border border-radix-ruby-6 dark:border-radix-ruby-6/10";
		case SET_STATUSES.MUST_SEE:
			return "bg-radix-violet-4 dark:bg-radix-violet-9/30 border border-radix-violet-6 dark:border-radix-violet-6/10";
		case SET_STATUSES.SCHEDULED:
			return "bg-radix-plum-4 dark:bg-radix-plum-9/30 border border-radix-plum-6 dark:border-radix-plum-6/10";
		default:
			return baseClass;
	}
}

/**
 * Gets CSS classes for set card hover state based on status
 */
export function getSetCardHoverClassName(status: SetStatus): string {
	switch (status) {
		case SET_STATUSES.SAW_LIVE:
			return "hover:bg-radix-indigo-5 dark:hover:bg-radix-indigo-10/30";
		case SET_STATUSES.SAW_STREAM:
			return "hover:bg-radix-ruby-5 dark:hover:bg-radix-ruby-10/30";
		case SET_STATUSES.MUST_SEE:
			return "hover:bg-radix-violet-5 dark:hover:bg-radix-violet-10/30";
		case SET_STATUSES.SCHEDULED:
			return "hover:bg-radix-plum-5 dark:hover:bg-radix-plum-10/30";
		default:
			return "hover:bg-muted/30 dark:hover:bg-muted/10";
	}
}

/**
 * Gets CSS classes for set card active state based on status
 */
export function getSetCardActiveClassName(status: SetStatus): string {
	switch (status) {
		case SET_STATUSES.SAW_LIVE:
			return "active:bg-radix-indigo-6 dark:active:bg-radix-indigo-11/30";
		case SET_STATUSES.SAW_STREAM:
			return "active:bg-radix-ruby-6 dark:active:bg-radix-ruby-11/30";
		case SET_STATUSES.MUST_SEE:
			return "active:bg-radix-violet-6 dark:active:bg-radix-violet-11/30";
		case SET_STATUSES.SCHEDULED:
			return "active:bg-radix-plum-6 dark:active:bg-radix-plum-11/30";
		default:
			return "active:bg-muted/50 dark:active:bg-muted/20";
	}
}

/**
 * Gets CSS classes for status button based on status
 */
export function getSetButtonClassName(status: SetStatus): string {
	switch (status) {
		case SET_STATUSES.SAW_LIVE:
			return "bg-radix-indigo-9 hover:bg-radix-indigo-10 active:bg-radix-indigo-11 text-radix-indigo-1 border border-radix-indigo-6/10";
		case SET_STATUSES.SAW_STREAM:
			return "bg-radix-ruby-9 hover:bg-radix-ruby-10 active:bg-radix-ruby-11 text-radix-ruby-1 border border-radix-ruby-6/10";
		case SET_STATUSES.MUST_SEE:
			return "bg-radix-violet-9 hover:bg-radix-violet-10 active:bg-radix-violet-11 text-radix-violet-1 border border-radix-violet-6/10";
		case SET_STATUSES.SCHEDULED:
			return "bg-radix-plum-9 hover:bg-radix-plum-10 active:bg-radix-plum-11 text-radix-plum-1 border border-radix-plum-6/10";
		default:
			return "bg-muted/50 hover:bg-muted/80 active:bg-muted text-foreground/80 border border-border";
	}
}
